export const pattern17Data = [
  {
    koreanChunks: [
      "당신은 선택할 수 있다",

      "어떤것이든",
      "좌석이 이용가능한",
      "앞줄에",
    ],
    englishChunks: [
      "You may choose",
      "whichever",
      "seat is available",
      "in the front row",
    ],
    fullEnglish: "You may choose whichever seat is available in the front row.",
    additionalExplanation:
      "whichever를 쓰려고 하는 순간은 '여러 가지 중에서 어떤 것이든'이라는 말을 하고 싶을 때 떠올리는 단어입니다. '어떤 것이든'이라고 먼저 말해서 강조를 하고, 그 어떤 것에 대한 설명을 뒤에 붙여 말합니다. 아, 원어민들은 우선 어떤 것이든이라고 말한 다음에 뒤에 문장으로 보충하는구나, 이렇게 생각해봅니다",
  },
  {
    koreanChunks: [
      "회사는 펀드를 할 것이다",
      "어떤것이든",
      "프로젝트가 받는 가장 높은 승인을",
      "이사회로부터",
    ],
    englishChunks: [
      "The company will fund",
      "whichever",
      "project receives the highest approval",
      "from the board",
    ],
    fullEnglish:
      "The company will fund whichever project receives the highest approval from the board.",
    additionalExplanation:
      "마찬가지로 프로젝트 중에서 가장 높은 승인을 받는, 즉 여러 가지 중에서 어떤 것이든이라는 말을 하고 싶을 때, '어떤 것이든'이라고 먼저 말해서 강조를 하고 그 어떤 것에 대한 설명을 하는 걸 볼 수 있습니다. 아, 원어민들은 우선 어떤 것이든이라고 말한 다음에 뒤에 문장으로 이어서 말하는구나, 이렇게 생각해봅니다.",
  },
  {
    koreanChunks: [
      "직원들은 사용할 수 있다",
      "어떤것이든",
      "소프트웨어 도구가 가장 잘 맞는 그들의 업무 흐름에",
    ],
    englishChunks: [
      "Employees can use",
      "whichever",
      "software tool best suits their workflow",
    ],
    fullEnglish:
      "Employees can use whichever software tool best suits their workflow.",
    additionalExplanation:
      "마찬가지로 '어떤 것이든' 말하고 그 '어떤 것이든 = 소프트웨어 도구가 가장 잘 맞는' 으로 뒤에서 더 붙이면서 설명하는 걸 볼 수 있습니다. 영어 어순대로 말할 경우 어떤 단어가 먼저 나오고, 어떻게 설명을 붙이는지 보면서 훈련해보세요",
  },
  {
    koreanChunks: [
      "매니저는 지원할 것이다",
      "무엇이든",
      "결정을",
      "그.. 팀이 동의하는",
    ],
    englishChunks: [
      "The manager will support",
      "whatever",
      "decision",
      "the team agrees on",
    ],
    fullEnglish:
      "The manager will support whatever decision the team agrees on.",
    additionalExplanation:
      "무엇이든 상관없는 경우, 종류 안에서 구분 없이 무엇이든 상관없다는 말을 하고 싶을 때 원어민들은 'whatever'를 먼저 말하고 그 뒤에 설명을 붙입니다. 지금 이 문장은 무엇이든지에 해당하는 게 결정(decision)이고 뒤에 그 결정을 꾸미는 문장을 붙여 설명하는 걸 볼 수 있습니다. 이 흐름을 그대로 익숙해져 보려고 해보세요.",
  },
  {
    koreanChunks: [
      "고객들은 반품할 수 있다",
      "무엇이든",
      "물건들을",
      "그.. 그들이 만족하지 않는",
    ],
    englishChunks: [
      "Customers can return",
      "whatever",
      "items",
      "they are not satisfied with",
    ],
    fullEnglish:
      "Customers can return whatever items they are not satisfied with.",
    additionalExplanation:
      "이 문장에서도 '무엇이든(whatever)'이 먼저 나오고 그 뒤에 물건들(items)이라는 명사가 오며, 그다음에 설명하는 문장이 이어집니다. 한국어라면 마지막에 나올 말인데 영어에선 앞에 나오고 설명하는 구조인 것을 유심히 보세요.",
  },
  {
    koreanChunks: [
      "매니저가",
      "그.. 승인한 당신의 제안을",
      "연락할 것입니다",
      "당신에게 곧",
    ],
    englishChunks: [
      "The manager",
      "who approved your proposal",
      "will contact",
      "you shortly",
    ],
    fullEnglish:
      "The manager who approved your proposal will contact you shortly.",
    additionalExplanation:
      "원어민 입장이 되봅시다. 어떤 사람을 말했고, 그 사람을 주체로 뭔가 더 말하고 싶을 때 who를 씁니다.",
  },
  {
    koreanChunks: [
      "엔지니어는",
      "그.. 회사가 최근에 고용한",
      "전문가이다",
      "AI 시스템에",
    ],
    englishChunks: [
      "The engineer,",
      "whom the company recently hired,",
      "specializes",
      "in AI systems",
    ],
    fullEnglish:
      "The engineer, whom the company recently hired, specializes in AI systems.",
    additionalExplanation:
      "이 원어민이 하고 싶은 말은 결국 엔지니어가 AI 시스템에 매우 특화되어 있다는 것입니다. 그런데 그 엔지니어에 대한 정보를 중간에 듣는 이에게 살짝 더 보충해주려고 하려고 관계사를 씁니다. 그런데 who는 내가 방금 말한 사람을 주체로 더 말하고 싶을 때 쓴다면, whom은 내가 방금 언급한 사람이 어떤 행동의 대상이었고 그걸 더 말하고 싶을 때 whom을 씁니다.",
  },
  {
    koreanChunks: [
      "사용해보세요 우리의 새 기기를",
      "그.. 받은 가장 높은 만족도 평가를",
    ],
    englishChunks: [
      "Try our new device",
      "which received the highest satisfaction ratings",
    ],
    fullEnglish:
      "Try our new device which received the highest satisfaction ratings.",
    additionalExplanation:
      "우선 원어민이 하고 싶은 말은 새 기기를 사용해보라는 것이고 그 새 기기에 대한 설명을 좀 더 해주고자 할 때 which를 씁니다. 어떤 사물을 말했고, 그 사물을 주체로 뭔가 더 말하고 싶을 때는 which라는 단어를 떠올리는구나, 라고 생각합니다.",
  },
  {
    koreanChunks: [
      "지원자들은",
      "그... 이력서가 선택된",
      "초대될 것입니다",
      "면접에",
    ],
    englishChunks: [
      "Applicants",
      "whose resumes are selected",
      "will be invited",
      "for an interview",
    ],
    fullEnglish:
      "Applicants whose resumes are selected will be invited for an interview.",
    additionalExplanation:
      "우선 하고 싶은 말은 지원자들이 초대될 것이다가 가장 메인이고 여기서 그 지원자들에 대해 더 자세히 상대방에게 정보를 주고 싶을 때, 말하려는 내용이 그 사람의 어떤, 이렇게 소유격으로 그 사람의, 누구의, 라고 시작하며 설명하고 싶을 때 사용합니다. ",
  },
  {
    koreanChunks: ["인턴은", "그... 답변한 고객 문의에", "칭찬을 받았다"],
    englishChunks: [
      "The intern",
      "who answered the customer inquiry",
      "was praised",
    ],
    fullEnglish: "The intern who answered the customer inquiry was praised.",
    additionalExplanation:
      "인턴은, 하고 그냥 인턴이라고 말하면 부족하니 더 설명을 붙일 때 who를 쓰는 것입니다. 특히 그 사람을 주체로 뭔가 더 말하고 싶을 때 who를 씁니다. 여기서는 인턴이 칭찬을 받았다는 게 가장 주 내용입니다. 그러나 우리가 말할 때도 그 .. 하며 자세히 좀 더 상대방에게 정보를 주려고 하듯 원어민도 관계사를 이렇게 사용한다는 걸 볼 수 있습니다. ",
  },
  {
    koreanChunks: [
      "여성은",
      "그... 당신이 대화한 같이",
      "프로젝트 매니저입니다",
    ],
    englishChunks: [
      "The woman",
      "whom you spoke with",
      "is the project manager",
    ],
    fullEnglish: "The woman whom you spoke with is the project manager.",
    additionalExplanation:
      "여기서 주요 내용은 그 여성이 프로젝트 매니저라는 것입니다. 그런데 어떤 여성인지 듣는 사람에게 더 알려주기 위해 whom을 썼는데요, 대화체에서는 보통 who를 사용합니다. 그러나 격식 있는 말투를 쓰고 싶을 때, 좀 더 정확하게 말해야 할 때는 whom을 씁니다. '그 어제 네가 같이 대화했던 그 여자'라고 말하고 싶을 때 who도 되지만 격식을 차리거나, 공식 문서, 글쓰기에서 이렇게 목적격을 사용합니다.",
  },
  {
    koreanChunks: [
      "후보자는",
      "그... 디렉터가 선택한",
      "다음 주에 시작할 것입니다",
    ],
    englishChunks: [
      "The candidate",
      "whom the director selected",
      "will start next week",
    ],
    fullEnglish:
      "The candidate whom the director selected will start next week.",
    additionalExplanation:
      "이 문장에서 주요 내용은 후보자가 다음 주에 시작한다는 것입니다. 그런데 어떤 후보자인지 더 명확히 하기 위해 관계대명사 whom을 사용했습니다. 여기서 후보자는 디렉터가 선택한 대상이므로 목적격 관계대명사 whom을 사용했습니다.",
  },

  {
    koreanChunks: ["연사는", "그... 발표한", "세미나에서", "매우 흥미로웠다"],
    englishChunks: [
      "The speaker",
      "who presented",
      " at the seminar",
      "was very engaging",
    ],
    fullEnglish: "The speaker who presented at the seminar was very engaging.",
    additionalExplanation:
      "이 문장에서 주요 내용은 연사가 매우 흥미로웠다는 것입니다. 어떤 연사인지 듣는이에게 더 자세히 알려주고 싶어서 who를 사용했는데요 특히 이 연사를 주체로 뭔가 더 말하고 싶을때 who를 사용합니다.",
  },
  {
    koreanChunks: [
      "지원자는",
      "그... 우리가 면접했던 어제",
      "가졌다 강한 자격들을",
    ],
    englishChunks: [
      "The applicant",
      "whom we interviewed yesterday",
      "had strong qualifications",
    ],
    fullEnglish:
      "The applicant whom we interviewed yesterday had strong qualifications.",
    additionalExplanation:
      "이 문장에서 주요 내용은 지원자가 강한 자격을 갖추고 있었다는 것입니다. 어떤 지원자였는지 격식을 차리며 더 이야기해주고 싶거나, 그 지원자가 뭘 한걸 강조하기보단 어떤 행동의 대상이었고 그걸 더 말하고 싶을 때 whom을 사용합니다.",
  },
  {
    koreanChunks: ["직원은", "그... 계약이 끝나는 곧", "받을 것이다 연장을"],
    englishChunks: [
      "The employee",
      "whose contract ends soon",
      "will receive an extension",
    ],
    fullEnglish:
      "The employee whose contract ends soon will receive an extension.",
    additionalExplanation:
      "이 문장에서 주요 내용은 직원이 연장을 받을 것이라는 점입니다. 어떤 직원인지 더 명확히 하기 위해 whose를 선택했는데요, 그 사람에게 속한 것이 더 중요한 정보일 경우 whose가 나옵니다. 여기서는 그 사람의 계약을 강조하고 싶은 것으로 소유격 whose를 썼습니다. 이런 문장을 많이 읽어보면 익숙해질 겁니다.",
  },
  {
    koreanChunks: ["직원은", "그... 제출한 보고서를", "받을 것이다 보너스를"],
    englishChunks: [
      "The employee",
      "who submitted the report",
      "will receive a bonus",
    ],
    fullEnglish: "The employee who submitted the report will receive a bonus.",
    additionalExplanation:
      "이 문장에서 주요 내용은 직원이 보너스를 받을 것이라는 점입니다. 어떤 직원인지 더 말하고 싶어서 who를 선택했는데요, 특히 이 원어민이 그 사람을 주체로 뭔가 더 말하고 싶을 때 who를 씁니다. ",
  },
  {
    koreanChunks: [
      "매니저는",
      "그... 이끄는 마케팅 팀을",
      "은퇴할 것이다 다음 달에",
    ],
    englishChunks: [
      "The manager",
      "who leads the marketing team",
      "is retiring next month",
    ],
    fullEnglish:
      "The manager who leads the marketing team is retiring next month.",
    additionalExplanation:
      "이 문장에서 주요 내용은 매니저가 다음 달에 은퇴한다는 것입니다. 듣는이에게 자기가 말하는 매니저란 누군지 더 말해주고 싶을 때 who를 쓰는 걸 볼 수 있습니다. 특히 이 매니저를 주체로 뭔가 더 말하고 싶을 때는 주격 who를 사용합니다.",
  },
  {
    koreanChunks: [
      "고객들은",
      "그... 우리가 초대한 행사에",
      "주었다 긍정적인 피드백을",
    ],
    englishChunks: [
      "The clients",
      "whom we invited to the event",
      "gave positive feedback",
    ],
    fullEnglish:
      "The clients whom we invited to the event gave positive feedback.",
    additionalExplanation:
      "이 문장에서 주요 내용은 고객들이 긍정적인 피드백을 주었다는 것입니다. 듣는 이에게 자기가 말하는 고객들이 누군지 더 말해주고 싶은데, 고객들이 뭘 한 걸 강조하기보다 고객들이 초대라는 행동의 대상이었고 그걸 더 말하고 싶을 때 whom을 사용합니다. ",
  },
  {
    koreanChunks: [
      "소프트웨어는",
      "그... 우리가 (현재) 사용중인",
      "오래되었다",
    ],
    englishChunks: ["The software", "which we are using", "is outdated"],
    fullEnglish: "The software which we are using is outdated.",
    additionalExplanation:
      "이 문장에서 주요 내용은 소프트웨어가 오래되었다는 것입니다. 듣는 이에게 자신이 말하는 소프트웨어란 뭔지 알려주고자 which를 썼습니다. 사람이 아닌 경우 which를 씁니다.  ",
  },
  {
    koreanChunks: ["정책은", "그... 적용되는 모든 부서에", "업데이트될 것이다"],
    englishChunks: [
      "The policy",
      "which applies to all departments",
      "will be updated",
    ],
    fullEnglish: "The policy which applies to all departments will be updated.",
    additionalExplanation:
      "이 문장에서 주요 내용은 정책이 업데이트될 것이라는 점입니다. 듣는 이에게 어떤 정책인지 더 설명하기 위해 which를 사용했습니다. 정책은 사람이 아니므로 which를 사용하는 것이 적절합니다.",
  },
  {
    koreanChunks: ["보고서는", "그... 제출된 어제", "오류가 있다"],
    englishChunks: [
      "The report",
      "which was submitted yesterday",
      "has errors",
    ],
    fullEnglish: "The report which was submitted yesterday has errors.",
    additionalExplanation:
      "이 문장에서 주요 내용은 보고서에 오류가 있다는 것입니다. 듣는 이에게 어떤 보고서인지 더 설명하기 위해 which를 사용했습니다. 보고서는 사람이 아닌 사물이므로 which를 사용하는 것이 적절합니다.",
  },

  {
    koreanChunks: [
      "지원자는",
      "그.... 경험이 일치하는 우리의 필요와",
      "최종 후보에 오를 것이다",
    ],
    englishChunks: [
      "The applicant",
      "whose experience matches our needs",
      "will be shortlisted",
    ],
    fullEnglish:
      "The applicant whose experience matches our needs will be shortlisted.",
    additionalExplanation:
      "이 문장에서 주요 내용은 지원자가 최종 후보에 오를 것이라는 점입니다. 듣는 이에게 자기가 말하는 지원자의 경험에 대해 더 얘기하고 싶어서 whose를 사용했습니다. 이처럼 그 사람에게 속한 것에 대해 얘기하는 경우 whose가 나옵니다. ",
  },
  {
    koreanChunks: [
      "고객은",
      "그... 불만이 해결되지 않은",
      "연락했다 우리에게 다시",
    ],
    englishChunks: [
      "The client",
      "whose complaint was unresolved",
      "contacted us again",
    ],
    fullEnglish:
      "The client whose complaint was unresolved contacted us again.",
    additionalExplanation:
      "이 문장에서 주요 내용은 고객이 우리에게 다시 연락했다는 것입니다. 고객의 불만에 대해 더 얘기하고 싶어서 whose를 사용했습니다. 이처럼 그 고객에게 속한것이 중요한 정보면 whose가 나옵니다.",
  },
  {
    koreanChunks: ["매니저는", "그... 내가 이야기한", "참석할 것이다 회의에"],
    englishChunks: ["The manager", "whom I spoke to", "will join the meeting"],
    fullEnglish: "The manager whom I spoke to will join the meeting.",
    additionalExplanation:
      "이 문장에서 주요 내용은 매니저가 회의에 참석할 것이라는 점입니다. 듣는 이에게 어떤 매니저인지 더 설명하기 위해 whom을 사용했습니다. 매니저는 사람이므로 which 대신 whom을 사용하는 것이 적절합니다.대화체에서는 보통 who를 사용합니다. 그러나 격식 있는 말투를 쓰고 싶을 때, 좀 더 정확하게 말해야 할 때는 whom을 씁니다. 여기서는 매니저가 뭘 했단걸 강조하기 보단 자신이 말한, 대상이다 라고 더 말하고 싶을 때는 whom을 사용합니다.",
  },
  {
    koreanChunks: ["고객들은", "그... 주문이 지연된", "받을 것이다 보상을"],
    englishChunks: [
      "Customers",
      "whose orders are delayed",
      "will receive compensation",
    ],
    fullEnglish:
      "Customers whose orders are delayed will receive compensation.",
    additionalExplanation:
      "이 문장에서 주요 내용은 고객들이 보상을 받을 것이라는 점입니다. 어떤 고객들인지 더 설명하기 위해 whose를 사용했습니다. 이처럼 어떤 고객들인지 설명할 때 그 고객에게 속한 것이 더 중요한 정보면 whose를 이용해서 말합니다.",
  },
  {
    koreanChunks: ["결정은", "그... 이사회가 내린", "발표될 것이다 내일"],
    englishChunks: [
      "The decision",
      "that the board made",
      "will be announced tomorrow",
    ],
    fullEnglish: "The decision that the board made will be announced tomorrow.",
    additionalExplanation:
      "그냥 결정이 아니라 딱 그 특정한 결정을 명확하게 알려주고 싶을 때는 원어민들은 that을 선택합니다. which도 이 문장에서 쓰일 수 있지만 that이 좀 더 어떤 것을 정확히 한정하고 싶을 때 사용합니다..",
  },
  {
    koreanChunks: ["노트북은", "그... 내가 구매한 지난주에", "결함이 있다"],
    englishChunks: ["The laptop", "that I bought last week", "is defective"],
    fullEnglish: "The laptop that I bought last week is defective.",
    additionalExplanation:
      "마찬가지로 노트북이 그냥 노트북이 아니라 자신이 구매한 노트북이라고 명확히 지정하고 싶을 때 사용 합니다.",
  },
  {
    koreanChunks: ["예산은", "그... 제안된", "승인되었다 빠르게"],
    englishChunks: ["The budget", "that was proposed", "was approved quickly"],
    fullEnglish: "The budget that was proposed was approved quickly.",
    additionalExplanation:
      "물론 예산이 승인됐다, 그것도 빠르게 이 내용이 주된 내용이지만 여기서 말하는 사람이 그냥 예산이 아니라 딱 어떤 예산이다라고 말하고 싶을 때 that을 씁니다. which가 못 오는 게 아니라 올 수도 있지만 좀 더 제한적, 단정하고 싶을 때 원어민들은 that이 자연스럽게 나오는구나.. 이렇게 생각합니다",
  },
  {
    koreanChunks: ["알려주세요", "언제 당신이 가능할지", " 다음 회의를 위해"],
    englishChunks: [
      "Please let us know",
      "when you will be available",
      "for the next meeting",
    ],
    fullEnglish:
      "Please let us know when you will be available for the next meeting.",
    additionalExplanation:
      " '당신이'가 먼저 나오지 않고 '언제'가 먼저 나오는 걸 알 수 있습니다 계속 영어 어순에 익숙해져야 합니다. ",
  },
  {
    koreanChunks: [
      "회사는",
      "열었다",
      "새 지점을",
      "부산에",
      "그... 수요가 급증하고 있는",
    ],
    englishChunks: [
      "The company",
      "opened",
      " a new branch",
      "in Busan",
      "where demand is growing rapidly",
    ],
    fullEnglish:
      "The company opened a new branch in Busan, where demand is growing rapidly.",
    additionalExplanation:
      "물론 이 문장은 회사가 새 지점을 열었다는 게 주 문장입니다. 그리고 부산에 대해 좀 더 얘기하고 싶어서 화자가 where를 사용했습니다. which, that도 올 수 있죠. 그러나 원어민들은 어떤 공간들에 대해 더 추가로 설명할 때는 where를 씁니다. 여기서 공간이란 장소도 있지만 상황, 단계, 시점 등 다양한 것들이 올 수 있습니다. 많은 문장으로 익숙해져야 합니다.",
  },
  {
    koreanChunks: [
      "보고서는",
      "설명한다",
      "시나리오를",
      "그... 비용이 초과할 수 있는 예상치를",
    ],
    englishChunks: [
      "The report",
      "outlines",
      "a scenario",
      "where costs could exceed projections",
    ],
    fullEnglish:
      "The report outlines a scenario where costs could exceed projections.",
    additionalExplanation:
      "where=장소 이렇게 생각하지 않아야 합니다. 시나리오라는 상황을 더 듣는이에게 얘기하주려고 where를 사용한 걸 볼 수 있습니다.",
  },
  {
    koreanChunks: [
      "우리는 들어가고 있다",
      "단계에",
      "그... 빠른 의사결정이 필수적인",
    ],
    englishChunks: [
      "We are entering",
      "a phase",
      "where quick decision-making is essential",
    ],
    fullEnglish:
      "We are entering a phase where quick decision-making is essential.",
    additionalExplanation:
      "우리가 어떤 단계에 들어가고 있고 그 단계라는 공간적 상황, 그 안에서 벌어지는 일을 자연스럽게 얘기할 때는 where를 씁니다. 너무 수학처럼 언어를 딱 정하지 말고 원어민들은 이렇게 하는구나, 하고 넓은 마음으로 영어를 봐야 합니다.",
  },
  {
    koreanChunks: [
      "우리는 필요하다 시스템이",
      "그... 모든 부서가 협업할 수 있는 효과적으로",
    ],
    englishChunks: [
      "We need a system",
      "where all departments can collaborate effectively",
    ],
    fullEnglish:
      "We need a system where all departments can collaborate effectively.",
    additionalExplanation:
      "이 문장에서 '시스템'이라는 개념적 공간에 대해 더 설명하기 위해 'where'를 사용했습니다. 물리적 장소가 아니더라도 상황이나 환경을 설명할 때 'where'를 자연스럽게 사용하는 예시입니다. 시스템이라는 환경 안에서 부서들이 협업한다는 의미를 전달합니다.",
  },

  {
    koreanChunks: [
      "우리는 직면하고 있다",
      "상황에",
      "그... 즉각적인 조치가 필요한",
    ],
    englishChunks: [
      "We are facing",
      "conditions",
      "where immediate action is required",
    ],
    fullEnglish: "We are facing conditions where immediate action is required.",
    additionalExplanation:
      "이 문장에서 '상황(conditions)'이라는 개념적 환경을 설명하기 위해 'where'를 사용했습니다. 물리적 장소가 아닌 우리가 직면한 상황이나 조건을 더 자세히 설명할 때 'where'를 활용하는 예시입니다. 이는 특정 상황 내에서 필요한 행동을 설명하는 자연스러운 표현입니다.",
  },
  {
    koreanChunks: ["우리는 만들고자 한다", "환경을", "그... 혁신이 장려되는"],
    englishChunks: [
      "We aim to create",
      "an environment",
      "where innovation is encouraged",
    ],
    fullEnglish:
      "We aim to create an environment where innovation is encouraged.",
    additionalExplanation:
      "이 문장에서 '환경(environment)'이라는 개념적 공간을 설명하기 위해 'where'를 사용했습니다. 물리적인 장소보다는 우리가 만들고자 하는 분위기나 상황을 설명할 때 'where'를 자연스럽게 활용한 예시입니다. 혁신이 장려되는 환경이라는 상황을 더 구체적으로 설명하고 있습니다.",
  },
  {
    koreanChunks: [
      "이것은 하나이다 몇 개의 산업들 중",
      "그... 성장이 (현재)유지됬던 안정적으로",
    ],
    englishChunks: [
      "This is one of the few industries",
      "where growth has remained stable",
    ],
    fullEnglish:
      "This is one of the few industries where growth has remained stable.",
    additionalExplanation:
      "이 문장에서 '산업(industries)'이라는 개념적 영역을 설명하기 위해 'where'를 사용했습니다. 물리적 장소가 아닌 특정 산업 분야의 상태나 특성을 설명할 때 'where'를 자연스럽게 활용한 예시입니다. 성장이 안정적으로 유지되는 산업이라는 특성을 더 구체적으로 설명하고 있습니다.",
  },
  {
    koreanChunks: ["서울은 도시이다", "그... 컨퍼런스가 열릴"],
    englishChunks: [
      "Seoul is the city",
      "where the conference will take place",
    ],
    fullEnglish: "Seoul is the city where the conference will take place.",
    additionalExplanation:
      "이 문장에서 '도시(city)'라는 물리적 장소를 설명하기 위해 'where'를 사용했습니다. ",
  },
  {
    koreanChunks: [
      "발견하세요 이유를",
      "왜 많은 사용자들이 선택하는지",
      "우리 서비스를",
    ],
    englishChunks: [
      "Discover the reason",
      "why so many users choose",
      "our service",
    ],
    fullEnglish: "Discover the reason why so many users choose our service.",
    additionalExplanation:
      "Reason을 더 구체적으로 설명하고자 why를 사용했습니다. 이유를 설명할 때는 which, that 이런 것말고 why를 쓰는구나..하고 원어민들이 그렇게 쓰는구나 하고 자연스럽게 받아들여보세요. 이래야 한다는 개념을 없애야 합니다.",
  },
  {
    koreanChunks: [
      "이것이 방법이다",
      "어떻게 리셋하는지 당신의 계정 비밀번호를 안전하게",
    ],
    englishChunks: [
      "This is the way",
      "how to reset your account password",
      "safely",
    ],
    fullEnglish: "This is the way how to reset your account password safely.",
    additionalExplanation:
      "이 문장에서 '방법(way)'을 설명하기 위해 'how'를 사용했습니다. 방법이나 절차를 설명할 때는 'how'가 자연스럽게 사용됩니다. 계정 비밀번호를 안전하게 재설정하는 방법에 대해 구체적으로 설명하고 있습니다.",
  },
  {
    koreanChunks: [
      "우리는 고용할 것이다",
      "누구든지",
      "가장 자격이 있는",
      "그 직책에",
    ],
    englishChunks: [
      "We will hire",
      "whoever",
      "is most qualified",
      "for the position",
    ],
    fullEnglish: "We will hire whoever is most qualified for the position.",
    additionalExplanation:
      "결국 말하고 싶은 것은 처음에 누구든지 고용할 것이다라는 것이고 이후 그 누구든지에 대해 얘기하는 식입니다. 영어 어순에 익숙해지면서 원어민이 이런 말을 하려면 무슨 단어를 떠올릴까? 하는 접근으로 생각해보세요. 범위를 제한하지 않고 조건을 충족하는 사람이면 누구든지라는 느낌을 표현할 때 whoever를 쓰는구나 생각해봅니다.",
  },
  {
    koreanChunks: [
      "그 자리는 주어질 예정입니다",
      "누구든지",
      "충족하는",
      "모든 조건을",
    ],
    englishChunks: [
      "The position will be given to",
      "whoever",
      "meets all the requirements",
    ],
    fullEnglish:
      "The position will be given to whoever meets all the requirements.",
    additionalExplanation:
      "이 문장에서 '누구든지(whoever)'는 조건을 충족하는 모든 사람을 지칭합니다. 'whoever'는 '누구든지'라는 의미로, 특정 조건을 만족하는 사람이면 누구나 해당된다는 뜻을 전달합니다. 이런 표현은 자격이나 조건을 강조할 때 자연스럽게 사용됩니다.",
  },
  {
    koreanChunks: [
      "당신은 연락할 수 있습니다 저에게",
      "언제든지",
      "당신이 질문이 있을 때",
    ],
    englishChunks: ["You can contact me", "whenever", "you have questions"],
    fullEnglish: "You can contact me whenever you have questions.",
    additionalExplanation:
      "정해진 시간이 없이 언제든지 그런 일이 일어날 때마다를 말하고 싶을 때 원어민들은 whenever를 먼저 말하고, '그런 일'에 대해 뒤에 붙여서 얘기합니다.",
  },
  {
    koreanChunks: [
      "직원들은 권장됩니다 질문하도록",
      "언제든지",
      "그들이 필요할 때 명확한 설명이 ",
    ],
    englishChunks: [
      "Employees are encouraged to ask questions",
      "whenever",
      "they need clarification",
    ],
    fullEnglish:
      "Employees are encouraged to ask questions whenever they need clarification.",
    additionalExplanation:
      "~할 때라면 언제든지 라고 할 때, 우선 whenever를 먼저 말하고 뒤에 그 ~ 할 때를 설명하는 구나라고 생각해보세요",
  },
  {
    koreanChunks: [
      "직원들은 할 수 있습니다 원격 근무를",
      "어디서든",
      "인터넷 연결이 가능한",
    ],
    englishChunks: [
      "Employees can work remotely",
      "wherever",
      "an internet connection is available",
    ],
    fullEnglish:
      "Employees can work remotely wherever an internet connection is available.",
    additionalExplanation:
      "이 문장에서 '어디서든(wherever)'은 장소에 관계없이 특정 조건(인터넷 연결)이 충족되는 모든 곳을 의미합니다. 'wherever'는 '어디서든지'라는 뜻으로, 장소에 제한을 두지 않고 조건만 만족하면 된다는 의미를 전달합니다. 마찬가지로 어디든지, 장소가 어디든 상관없이를 말하고 싶을 때 사용합니다",
  },
  {
    koreanChunks: [
      "고객들은 받을 수 있습니다 지원을",
      "어디서든",
      "그들이 위치해 있는",
    ],
    englishChunks: [
      "Customers can receive support",
      "wherever",
      "they are located",
    ],
    fullEnglish: "Customers can receive support wherever they are located.",
    additionalExplanation:
      "이 문장에서 '어디에 있든(wherever)'은 고객의 위치에 상관없이 지원을 받을 수 있다는 의미를 전달합니다. 'wherever'는 '어디에 있든지'라는 뜻으로, 장소에 제한 없이 모든 곳에서 적용된다는 것을 나타냅니다. ",
  },
  {
    koreanChunks: [
      "직원들은 선택할 수 있습니다",
      "무엇이든",
      "옵션을",
      "가장 적합한 그들의 업무 일정에",
    ],
    englishChunks: [
      "Employees may select",
      "whatever",
      "option",
      "best suits their work schedule",
    ],
    fullEnglish:
      "Employees may select whatever option best suits their work schedule.",
    additionalExplanation:
      "조건만 만족하면 무엇이든 이라는 말을 하고 싶을 때 먼저 whatever를 하고 그 무엇에 대한 설명을 뒤에 무엇(option)과 함께 설명을 추가하는 방법으로 표현합니다. whichever와의 차이는 선택지가 제한되어 있지 않은 상황입니다. 여기서 직원들이 선택할 수 있는 옵션 선택지를 제한하고 거기서 무엇이든 이란 게 아니라 그들 업무 일정에 적합하다면 무엇이든지를 말하는 것으로, 이런 식으로 선택지가 제한되지 않은 상황에서 무엇이든지를 표현할 때는 whatever를 사용하는구나, 라고 생각해보세요",
  },
  {
    koreanChunks: ["선택하세요", "어느 것이든지", "방법을", "가장 효율적인"],
    englishChunks: ["Choose", "whichever", "method", "is most efficient"],
    fullEnglish: "Choose whichever method is most efficient.",
    additionalExplanation:
      "이미 방법들이 있고 그중에서 어느 것이든지라는 것으로 whichever를 사용했습니다.",
  },
  {
    koreanChunks: [
      "우리는 지원할 것입니다",
      "어느 것이든",
      "제안을",
      "그 팀이 선택하는",
    ],
    englishChunks: [
      "We will support",
      "whichever",
      "proposal",
      "the team selects",
    ],
    fullEnglish: "We will support whichever proposal the team selects.",
    additionalExplanation:
      "여러 제안들처럼 어떤 선택지가 제한되있는 상황에서 팀이 어떤 것을 선택하든 그것을 지원하겠다는 뜻입니다. 'whichever'는 제한된 선택지 내에서의 선택을 나타낼 때 사용됩니다.",
  },
  {
    koreanChunks: [
      "회사는 투자할 것입니다",
      "어느 것이든",
      "프로젝트에",
      "보여주는 가장 많은 잠재력을",
    ],
    englishChunks: [
      "The company will invest in",
      "whichever",
      "project",
      "shows the most potential",
    ],
    fullEnglish:
      "The company will invest in whichever project shows the most potential.",
    additionalExplanation:
      "여러 프로젝트 중에서 가장 잠재력이 있는 것에 투자하겠다는 의미입니다. 'whichever'는 여러 선택지 중에서 특정 조건(여기서는 '가장 많은 잠재력을 보여주는')을 만족하는 것을 선택할 때 사용됩니다. 제한된 선택지(여러 프로젝트들) 내에서의 선택을 나타내므로 'whichever'가 적절합니다.",
  },
  {
    koreanChunks: [
      "제출하세요",
      "어느 것이든",
      "서류를",
      "적용 가능한 귀하의 사례에 ",
    ],
    englishChunks: [
      "Submit",
      "whichever",
      "documents",
      "are applicable to your case",
    ],
    fullEnglish: "Submit whichever documents are applicable to your case.",
    additionalExplanation:
      "여러 서류 중에서 귀하의 사례에 적용 가능한 것들을 제출하라는 의미입니다. 'whichever'는 제한된 선택지(여러 서류들) 내에서 특정 조건(귀하의 사례에 적용 가능한)을 만족하는 것을 선택할 때 사용됩니다. 이미 존재하는 서류들 중에서 선택하는 상황이므로 'whichever'가 적절합니다.",
  },
  {
    koreanChunks: ["사용하세요", "무엇이든", "자원을", "이용 가능한"],
    englishChunks: ["Use", "whatever", "resources", "are available"],
    fullEnglish: "Use whatever resources are available.",
    additionalExplanation:
      "이 문장은 '이용 가능한 모든 자원을 사용하라'는 의미입니다. 'whatever'는 종류나 수량에 제한 없이 '무엇이든지'라는 의미로 사용됩니다. 여기서는 자원의 종류나 양에 상관없이 사용 가능한 모든 것을 활용하라는 뜻으로, 선택의 폭이 넓거나 불특정한 경우에 'whatever'가 적절합니다.",
  },
  {
    koreanChunks: ["가지고 계셔도 됩니다", "무엇이든", "샘플들을", "남아있는"],
    englishChunks: ["You may keep", "whatever", "samples", "are left"],
    fullEnglish: "You may keep whatever samples are left.",
    additionalExplanation:
      "이 문장은 '남아있는 모든 샘플을 가지고 계셔도 된다'는 의미입니다. 'whatever'는 수량이나 종류에 제한 없이 '무엇이든지'라는 의미로 사용됩니다. 여기서는 남아있는 샘플이 무엇이든 상관없이 모두 가져도 된다는 의미로, 불특정하거나 제한되지 않은 대상을 가리킬 때 'whatever'가 적절합니다.",
  },
  {
    koreanChunks: ["포함하세요", "무엇이든", "비용을", "발생한"],
    englishChunks: ["Include", "whatever", "expenses", "were incurred"],
    fullEnglish: "Include whatever expenses were incurred.",
    additionalExplanation:
      "이 문장은 '발생한 모든 비용을 포함하세요'라는 의미입니다. 'whatever'는 종류나 수량에 제한 없이 '무엇이든지'라는 의미로 사용됩니다. 여기서는 발생한 비용이 어떤 것이든 상관없이 모두 포함하라는 뜻으로, 불특정하거나 제한되지 않은 비용을 가리킬 때 'whatever'가 적절합니다.",
  },
  {
    koreanChunks: [
      "참석할 수 있습니다",
      "어느 것이든",
      "세션을",
      "맞는 당신의 일정에",
    ],
    englishChunks: [
      "You may attend",
      "whichever",
      "session",
      "fits your schedule",
    ],
    fullEnglish: "You may attend whichever session fits your schedule.",
    additionalExplanation:
      " 여러 세션 중에서 선택하는 상황이므로 제한된 선택지 내에서의 선택을 나타내는 'whichever'가 적절합니다.",
  },
  {
    koreanChunks: [
      "선택하세요",
      "어느 것이든",
      "날짜를",
      "가장 편리한 당신에게",
    ],
    englishChunks: [
      "Please select",
      "whichever",
      "date",
      "is most convenient for you",
    ],
    fullEnglish: "Please select whichever date is most convenient for you.",
    additionalExplanation:
      "여러 날짜 중에서 하나를 고르는 상황이라고 느끼기에 선택의 개념이 있는 whichever를 씁니다. whatever가 올 경우 편한 날짜 아무거나 고르세요가 됩니다. 지금처럼 선택 대상이 정해져 있는 경우에서는 부자연스럽습니다.",
  },
  {
    koreanChunks: [
      "선택하세요",
      "어느 것이든",
      "옵션을",
      "가장 잘 맞는 당신의 예산에",
    ],
    englishChunks: ["Choose", "whichever", "option", "best suits your budget"],
    fullEnglish: "Choose whichever option best suits your budget.",
    additionalExplanation:
      "여러 옵션 중에서 선택하는 상황이므로 제한된 선택지 내에서의 선택을 나타내는 'whichever'가 적절합니다. 'whichever'는 '어느 것이든'이라는 의미로, 여러 가능한 선택지 중에서 조건(여기서는 예산에 맞는)에 부합하는 것을 선택할 때 사용됩니다.",
  },
];
